import { render } from "./BasicInformationView.vue?vue&type=template&id=f1d65d52&scoped=true"
import script from "./BasicInformationView.vue?vue&type=script&lang=js"
export * from "./BasicInformationView.vue?vue&type=script&lang=js"

import "./BasicInformationView.vue?vue&type=style&index=0&id=f1d65d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d65d52"]])

export default __exports__